import * as React from 'react';
import styled from 'styled-components';
import {mixinBtnSmall, mixinResetBtnCss, mixinBtnCancel, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";

interface IProps
    extends IBtnDefaultProps, React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

const BtnCancelSmallDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<button {...ButtonProps} />)

};

const BtnCancelSmall = styled(BtnCancelSmallDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnSmall}
    ${mixinBtnCancel}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnCancelSmall;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_cancel_small.tsx